import { render } from "./RestaurantConfirmDelete.vue?vue&type=template&id=e9b7f78e"
import script from "./RestaurantConfirmDelete.vue?vue&type=script&lang=js"
export * from "./RestaurantConfirmDelete.vue?vue&type=script&lang=js"

import "./RestaurantConfirmDelete.vue?vue&type=style&index=0&id=e9b7f78e&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__